import {
  Briefcase,
  TrendingUp,
  PieChart,
  LineChart,
  Users2,
} from "lucide-react";

const profiles = [
  {
    icon: Briefcase,
    title: "Investment Advisors & Wealth Consultants",
    description:
      "Professionals providing investment advice and wealth management services to clients.",
  },
  {
    icon: TrendingUp,
    title: "Private Equity & Venture Consultants",
    description:
      "Specialists in alternative investments and private market opportunities.",
  },
  {
    icon: PieChart,
    title: "Mutual Fund Distributors",
    description:
      "Authorized distributors of mutual funds and investment products.",
  },
  {
    icon: LineChart,
    title: "Stock Brokers & Capital Market Intermediaries",
    description:
      "Licensed professionals facilitating capital market transactions.",
  },
  {
    icon: Users2,
    title: "Professionals Working with HNIs, UHNIs & Family Offices",
    description:
      "Advisors serving high-net-worth individuals and institutional clients.",
  },
];

export default function WhoShouldAttend() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-white">
      <div className="container mx-auto max-w-7xl">
        {/* Heading */}
        <div className="text-center mb-16">
          <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#07162E] mb-6">
            Who Should Attend
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            This program is designed for capital market professionals and
            investment experts who are committed to elevating their practice to
            institutional standards.
          </p>
        </div>

        {/* ✅ Pyramid Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {profiles.map((profile, index) => {
            let positionClasses = "lg:col-span-2";

            // Bottom row positioning
            if (index === 3) positionClasses = "lg:col-span-2 lg:col-start-2";
            if (index === 4) positionClasses = "lg:col-span-2 lg:col-start-4";

            return (
              <div
                key={index}
                className={`group bg-white rounded-2xl p-8
                  shadow-[0_20px_50px_rgba(2,8,23,0.08)]
                  hover:shadow-[0_30px_70px_rgba(2,8,23,0.15)]
                  transition-all duration-300 transform hover:-translate-y-2
                  border border-transparent hover:border-[#0E6F7E]
                  ${positionClasses}`}
              >
                <div className="flex flex-col items-center text-center">
                  {/* Icon */}
                  <div
                    className="w-16 h-16 rounded-xl
                    bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                    flex items-center justify-center mb-5
                    group-hover:scale-110 transition-transform duration-300"
                  >
                    <profile.icon className="w-8 h-8 text-[#1DBF73]" />
                  </div>

                  {/* Content */}
                  <h3 className="text-lg font-bold text-[#07162E] mb-2">
                    {profile.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {profile.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
